import { Updater } from "widgets-for-react"

export const fieldUpdater =
  <s>() =>
  <k extends keyof s>(k: k) =>
  (updater: Updater<s[k]>) =>
  (state: s): s => ({ ...state, [k]: updater(state[k]) })

export const fieldReplacer =
  <s>() =>
  <k extends keyof s>(k: k) =>
  (value: s[k]) =>
  (state: s): s => ({ ...state, [k]: value })
